module.exports = __webpack_public_path__ + "img/pending.fa31e101.jpg";